import { apiClient } from "./ApiClient";

export async function sendContact(params) {
  const { data } = await apiClient.get("/partner/contact", {
    params: {
      name: params.name || "",
      email: params.email || "",
      subject: params.subject || "",
      message: params.message || "",
    },
    timeout: 10000, // 10s
  });

  return data;
}
